module.exports = __webpack_public_path__ + "SCTProfessional/static/dist/img/geo_pic.62c8df1d.png";